import { AppsState } from './types';

const initialState: AppsState = {
  data: undefined,
  isLoading: false,
};

export default initialState;
